import { FC } from 'react';
import './AccessDenied.scss';
import { useTranslation } from 'react-i18next';

const AccessDenied: FC = () => {
  const { t } = useTranslation();

  return <div className="no-access">{t('Access denied, No permissions')}</div>;
};

export default AccessDenied;
